export const DeliveryMethod = {
    PickupPoint: "pickup_point",
    SFCod: "sf_cod",
    SFLocker: "sf_locker"
}